import * as React from "react";

const Caex = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="29"
    height="35"
    fill="none"
    viewBox="0 0 29 35"
    {...props}

  >
    <path d="M25.75 0a2.42 2.42 0 0 1 2.417 2.417v30a2.417 2.417 0 0 1-2.417 2.416H2.417A2.417 2.417 0 0 1 0 32.417v-30A2.417 2.417 0 0 1 2.417 0zM9.083 27.5a.75.75 0 0 0 0 1.5h5.833l.077-.004a.75.75 0 0 0 0-1.492l-.077-.004zm0-5a.75.75 0 0 0 0 1.5h10l.077-.004a.75.75 0 0 0 0-1.492l-.077-.004zm5-16.666a4.083 4.083 0 0 0-2.557 7.266 5.75 5.75 0 0 0-3.193 5.15c0 .414.336.75.75.75h10a.75.75 0 0 0 .75-.75 5.75 5.75 0 0 0-3.193-5.15 4.08 4.08 0 0 0 1.527-3.183 4.084 4.084 0 0 0-4.084-4.083"></path>
  </svg>
);

export default Caex;

export const Dashboard = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="19"
    height="20"
    fill="none"
    {...props}
  >
    <path
      stroke="#024"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      d="M1.583 17.125h15.834"
    ></path>
    <path
      fill="#024"
      stroke="#024"
      strokeLinejoin="round"
      strokeWidth="1.5"
      d="M5.542 11.583H3.167v5.542h2.375zM10.688 7.625H8.312v9.5h2.376zM15.833 2.875h-2.375v14.25h2.375z"
    ></path>
  </svg>
);
